module.exports = "/assets/data/fe2116cde4b79e55ec10518e0b4a644e-RG8.data.json";